export default __webpack_public_path__ + "static/media/bi.66962d21.png";